module.exports = __webpack_public_path__ + "img/resized-20160625-191315.ef917483.jpg";